module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Contact#1-70b2f5b99caa685900d53aa51ba1174e.svg";